import { render } from "./FamilyFrances.vue?vue&type=template&id=3efaa815&scoped=true"
import script from "./FamilyFrances.vue?vue&type=script&lang=js"
export * from "./FamilyFrances.vue?vue&type=script&lang=js"

import "./FamilyFrances.vue?vue&type=style&index=0&id=3efaa815&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3efaa815"

export default script